module.exports = __webpack_public_path__ + "img/kerry-cool-box.9e330870.png";